<ng-template #cardTemplate>
  @for (item of items | async; track item) {
    <div>
      <app-role-slot [role]="item"></app-role-slot>
    </div>
  }
</ng-template>

<app-list title="Roles" i18n-title
  [actions]="actions"
  [cardTemplate]="cardTemplate">
</app-list>
